<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import Auth from '@/api/Auth.js'
import User from '@/api/User.js'

const props = defineProps({
  token: {
    type: String,
    default: ""
  }
});

const router = useRouter()
const userStore = useUserStore()

// components 
let password = ref('');
let status = ref('');
let isSubmitting = ref(false);
let success = ref(false)
let message = ref("")

const password_valid = computed(() => {
  return password.value != '' && password.value.length >= 8
})

const password_help = computed(() => {
  return password.value != '' && !password_valid.value
})

async function pwReset() {
    isSubmitting.value = true
    // const { data } = await axios.get(context.env.apiUrl + "/api/services"); 
    // should send a verification email ---- 2FA??
    // let {data} = await Auth.register(this.email, this.password)
    let data  = await User.reset_password(props.token, password.value)

    isSubmitting.value = false
    
    if(data.status) {
        success.value = true;            
    } else {
        message.value = data.message
    }
}

</script>

<template>
  <div class="login-container">
      <div class="box bordered p-5">
        <div v-if="!success">
          <h3 class="mb-4 jura text-center">Reset password</h3>
          <div class="text-center mb-4">Strong passwords include uppercase letters, numbers and symbols</div>
          <p v-if="!success" class="ms-1 danger mb-4">{{message}}</p>
          <form action="#" @submit.prevent="pwReset()" class="form-floating mb-4">
              <div class="mb-3">
                <div class="form-floating">
                    <input type="password" v-model="password" class="form-control dark" id="floatingPassword" placeholder="Password" :class="{invalid: password_help}">
                    <label for="floatingPassword">New password</label>
                </div>
                <div v-if="password_help" class="small ps-2 pe-2 mt-1">
                  Should be atleast 8 alphanumeric characters long
                </div>
              </div>
              <button  v-if="!isSubmitting" :disabled="!password || password.length < 8" type="submit" class="btn btn-primary submit-btn">Reset password</button>
              <button  v-else disabled type="submit" class="btn btn-primary submit-btn">resetting...</button>
          </form>
        </div>
        <div v-else>
          <h3 class="mb-4 jura text-center">Password reset!</h3>
          <p class="mb-4">If you encounter any issues, don't hesitate to reach out to our <a href="mailto:support@webscout.io">support team</a></p>
          <div v-if="userStore.loggedIn" class="text-center"><router-link to="/home" class="link" style="color: inherit;">Go to home</router-link> </div>
          <div v-else class="text-center"><router-link to="/login" class="link" style="color: inherit;">Go to login</router-link> </div>
        </div>
      </div>

  </div>
</template>


<style scoped>
.login-container {
  width: 450px;
}

.invalid {
  outline: 1px solid var(--color-error-text);
}

.wrapper {
    background-image: url('~@/assets/split-map.svg');
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 100%;
    background-size: 55%;
}

.danger {
    color: var(--color-error-text);
    font-size: 1rem;
}

.submit-btn {
    height: 64px;
    background-color: var(--surface-raised);
    font-size: 1rem;
    outline:none;
    width: 100%;
    box-shadow: none;
    border:none;
    border-radius: var(--radius-md);
}

#submit-btn:hover {
    background-color: #36404F;
}

.link:hover {
  text-decoration: underline;
}
</style>
